import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HStack } from "@astryxdesign/core/Stack";
import { TabList, Tab } from "@astryxdesign/core/TabList";
import { Button } from "@astryxdesign/core/Button";
import { getMonitor360WebUrl } from "../../config/productUrls";
import "../../fontawesome"; // Importar configuração do Font Awesome

/** Link externo p/ o Monitor 360 (abre em nova aba). */
function Monitor360NavLink({ href }) {
  return (
    <Button
      label="Monitor 360"
      variant="primary"
      icon={<FontAwesomeIcon icon="tachometer-alt" />}
      onClick={() => window.open(href, "_blank", "noopener,noreferrer")}
    />
  );
}

export default function Navigation({
  activeTab,
  setActiveTab,
  userRole,
  monitor360Href,
}) {
  // Abas por papel: cliente vê empresas+relatórios; admin/normal veem tudo
  // (usuários só p/ admin). Os values casam com o switch do App.jsx.
  const tabs =
    userRole === "cliente"
      ? [
          { value: "companies", label: "Minhas Empresas", icon: "building" },
          { value: "reports", label: "Relatórios", icon: "chart-bar" },
        ]
      : [
          { value: "companies", label: "Empresas", icon: "building" },
          { value: "files", label: "Notas Fiscais", icon: "folder-open" },
          { value: "fleet", label: "Coleta da Frota", icon: "satellite-dish" },
          { value: "reports", label: "Relatórios", icon: "chart-bar" },
          ...(userRole === "admin"
            ? [
                { value: "users", label: "Usuários", icon: "users-cog" },
                {
                  value: "conferencia-lancamentos",
                  label: "Conferência",
                  icon: "clipboard-check",
                },
              ]
            : []),
        ];

  const monitorHref = monitor360Href || getMonitor360WebUrl();

  return (
    <HStack gap={3} vAlign="center" wrap="wrap">
      <TabList label="Navegação" value={activeTab} onChange={setActiveTab}>
        {tabs.map((t) => (
          <Tab
            key={t.value}
            value={t.value}
            label={t.label}
            icon={<FontAwesomeIcon icon={t.icon} />}
          />
        ))}
      </TabList>
      <Monitor360NavLink href={monitorHref} />
    </HStack>
  );
}
